import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import BlurAmountView from 'design-system/BlurAmountView';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { formatAmount } from 'utils';
import Spacer from '../../../design-system/Spacer';
import StatusIcon from '../../../design-system/StatusIcon';
import IconEmmaWallet from '../../../design-system/icons/IconEmmaWallet';
import { IconBoldArrow } from '../../../design-system/icons/IconBoldArrow';
import { isWeb } from '../../../constants';
const Transaction = ({ type, title, status, formattedDate, amount, style }) => {
    const styles = useStyles(styleSet);
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const infoObj = useMemo(() => {
        if (type === 'DEPOSIT') {
            return {
                isDeposit: true,
                icon: <IconBoldArrow alt colorKey="brand" direction="right"/>,
                isRejected: status === 'failed',
            };
        }
        if (type === 'INTEREST') {
            return {
                isDeposit: true,
                icon: <IconEmmaWallet />,
            };
        }
        return {
            isDeposit: false,
            icon: <IconBoldArrow alt colorKey="brand"/>,
        };
    }, [type, status]);
    const textViewInfo = useMemo(() => {
        const formattedAmount = formatAmount(amount.value, amount.currency, 2);
        if (infoObj.isDeposit) {
            // positive
            if (infoObj.isRejected) {
                return { value: formattedAmount };
            }
            return { value: `+${formattedAmount}`, props: { Blue: true } };
        }
        return { value: `-${formattedAmount}` };
    }, [infoObj, amount]);
    return (<View style={style ? [styles.itemContainer, style] : styles.itemContainer}>
      <View style={styles.iconContainer}>{infoObj.icon}</View>
      <View style={styles.infoContainer}>
        <View style={styles.infoRow}>
          <View style={styles.infoContainer}>
            <Text Text-16 numberOfLines={1}>
              {title}
            </Text>
            {status === 'pending' && (<View style={styles.infoRow}>
                <StatusIcon state="in-progress" width={16} height={16}/>
                <Spacer.W8 />
                <View style={styles.infoContainer}>
                  <Text TextThin-14 numberOfLines={1} StatusInformational>
                    Pending
                  </Text>
                </View>
              </View>)}
            {infoObj.isRejected === true && (<View style={styles.infoRow}>
                <StatusIcon state="cancelled-red" width={16} height={16}/>
                <Spacer.W8 />
                <View style={styles.infoContainer}>
                  <Text TextThin-14 numberOfLines={1} Negative>
                    Rejected
                  </Text>
                </View>
              </View>)}
          </View>
        </View>
      </View>
      <View style={styles.rightContent}>
        <BlurAmountView enabled={scrambled}>
          <Text Numbers-16 {...textViewInfo.props}>
            {textViewInfo.value}
          </Text>
        </BlurAmountView>
        {!!formattedDate && (<Text TextThin-14 Gray flex>
            {formattedDate}
          </Text>)}
      </View>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    itemContainer: {
        flexDirection: 'row',
        paddingVertical: rem(16),
        paddingHorizontal: rem(16),
        alignItems: 'center',
        // On web the card is padded by 8 and each row by 8, so the hover highlight sits inside the card
        ...(isWeb && { paddingHorizontal: rem(8) }),
    },
    iconContainer: {
        width: rem(44),
        height: rem(44),
        alignItems: 'center',
        marginRight: rem(16),
        borderRadius: rem(44),
        justifyContent: 'center',
        backgroundColor: colors.background.brandLight,
    },
    infoContainer: {
        flex: 1,
    },
    infoRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    rightContent: {
        alignItems: 'flex-end',
        justifyContent: 'center',
    },
}));
export default memo(Transaction);
